import {useEffect} from 'react';
import Header from '../../components/ui/Header';
import HeroSection from "./components/HeroSection.tsx";
import ProblemSection from "./components/ProblemSection.tsx";
import SolutionOverview from "./components/SolutionOverview.tsx";
import BenefitsGrid from "./components/BenefitsGrid.tsx";
import TestimonialsSection from "./components/TestimonialsSection.tsx";
import SecuritySection from "./components/SecuritySection.tsx";
import DemoRequestSection from "./components/DemoRequest.tsx";
import FAQSection from "./components/FAQSection.tsx";
import Footer from "./components/Footer.tsx";

const LandingPage = () => {
    useEffect(() => {
        // Set page title
        document.title = 'Civicrate - Digital Revenue Platform for Ghana\'s Local Assemblies';

        // Add meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription?.setAttribute('content',
                'Transform your assembly operations with Civicrate - Ghana\'s leading digital revenue collection platform. Eliminate cash handling corruption with 100% digital transactions and full offline capabilities.'
            );
        }

        // Smooth scroll behavior
        document.documentElement.style.scrollBehavior = 'smooth';

        return () => {
            document.documentElement.style.scrollBehavior = 'auto';
        };
    }, []);

    return (
        <div className="min-h-screen bg-white">
            {/* Navigation Header */}
            <Header/>

            {/* Main Content */}
            <main className="pt-20">
                {/* Hero Section with Ghana Map and CTA */}
                <HeroSection/>

                {/* Problem Statement - Manual vs Digital Comparison */}
                <ProblemSection/>

                {/* Solution Overview - Interactive Module Showcase */}
                <SolutionOverview/>

                {/* Benefits Grid - Three Core Benefits */}
                <BenefitsGrid/>

                {/* Customer Testimonials with Video */}
                <TestimonialsSection/>

                {/* Security & Compliance Assurance */}
                <SecuritySection/>

                {/* Demo Request Form */}
                <DemoRequestSection/>

                {/* FAQ with Video Explanations */}
                <FAQSection/>
            </main>

            {/* Footer with Government Links */}
            <Footer/>
        </div>
    );
};

export default LandingPage;